import lyMap from './map.vue'

const lyMaps  = {
	install: (Vue)=>{
		Vue.component(lyMap.name,lyMap)
	}
}

export default lyMaps



// WEBPACK FOOTER //
// ./~/vue-ly-map/index.js